/** University / POI searches use "near"; cities and localities use "in". */
export const isUniversityRecentSearch = (place: any): boolean =>
  place?.region_type === "establishment" || Boolean(place?.filters?.university);

const recentSearchAbbreviation = (place: any): string => {
  const raw = place?.abbreviation ?? place?.region?.abbreviation;
  return typeof raw === "string" ? raw.trim() : "";
};

/** City/locality: full name. University: abbreviation when the region carries one. */
export const recentSearchDisplayName = (place: any): string => {
  const name = place?.name?.trim() || "";
  if (!isUniversityRecentSearch(place)) return name;
  return recentSearchAbbreviation(place) || name;
};

export const continueSearchSentenceKey = (
  place: any,
  surface: "welcomeDesktop" | "welcomePhone" | "heroCard",
): string => {
  const near = isUniversityRecentSearch(place);
  if (surface === "welcomePhone") {
    return near ? "home.v3.welcome.continuephone.near" : "home.v3.welcome.continuephone";
  }
  if (surface === "heroCard") {
    return near ? "home.herosection.continuesearchingnear" : "home.herosection.continuesearchingin";
  }
  return near ? "home.herosection.continuesearchingnear" : "home.herosection.continuesearchingin";
};

/** Payload for `recentlyVisited` when the search page has loaded a region. */
export const buildRecentSearchStorageEntry = (
  region: any,
  options: { filters: any; currency: string; country: string },
) => {
  const abbreviation = typeof region?.abbreviation === "string" ? region.abbreviation.trim() : "";
  return {
    id: region?.canonical_name,
    canonical_name: region?.canonical_name,
    name: region?.name,
    region_type: region?.region_type,
    filters: options.filters,
    currency: options.currency,
    name_zh: region?.name_zh ?? "",
    name_en: region?.name_en ?? "",
    ...(abbreviation ? { abbreviation } : {}),
    ...(region?.is_whitelabel_region && {
      is_whitelabel_region: region.is_whitelabel_region,
      whitelabel_partner_ids: region.whitelabel_partner_ids ?? [],
    }),
    country: options.country,
  };
};

/**
 * Maps a `recentlyVisited` localStorage entry's filters onto the search-URL params.
 */
export const getRecentSearchFilterParams = (place: any) => ({
  meta_min_lease_duration: place?.filters?.["minLeaseDuration"],
  meta_max_lease_duration: place?.filters?.["maxLeaseDuration"],
  move_in_month: place?.filters?.["moveInMonth"],
  meta_types: place?.filters?.["roomType"],
  range_available_price: place?.filters?.["budget"],
  available: !!place?.filters?.["available"],
  meta_unit_types: place?.filters?.["accommodationType"],
  tags: place?.filters?.["dualOccupancy"],
});

export default getRecentSearchFilterParams;
